import React from 'react'
import Title from '../layouts/Title'
import { stockMarketImage, eleNaImage, votingImage } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center mb-10">
        <Title
          // title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="Stock Trading Application"
          des="I developed the Stock Market Application, a sophisticated financial trading platform, which is available on GitHub. The project features a gRPC-based microservices architecture that efficiently handles stock lookup, trading, and catalog management, resulting in a 30% reduction in response time through optimized protocols and robust fault tolerance mechanisms. Additionally, I implemented RESTful APIs with caching, which boosted performance by 40%, ensuring fast and reliable data retrieval. Using Docker for containerization allowed seamless deployment and scaling, while socket programming enabled real-time data processing. I rigorously tested the platform's scalability for up to 100 clients, confirming its production readiness. This project demonstrates my ability to leverage modern technologies to build a high-performance, scalable, and fault-tolerant stock trading platform."
          src={stockMarketImage}
          githubLink="https://github.com/sairajesh368/stock-market-application"
          className="min-h-[300px]"
          
        />
        <ProjectsCard
          title="Voting Pattern Classification with Neural Networks"
          des="I developed a neural network model to classify voting patterns in the house votes dataset, achieving an average accuracy of 95% and an F1 score of 94%. The project involved meticulous Data Preprocessing, including normalization to ensure uniform feature scaling, which is crucial for model convergence. The Network Architecture featured an input layer with multiple features, hidden layers, and an output layer with two neurons representing the target classes. Forward Propagation calculated neuron activations using weighted sums and the sigmoid function, while Backward Propagation computed error gradients to adjust weights and minimize the cost function. Regularization techniques were applied to prevent overfitting, and the model's performance was optimized using gradient descent with a learning rate of 0.1 and a regularization parameter of 0.2. This project demonstrates my proficiency in advanced neural network techniques, yielding high accuracy and robust predictions."
          src={votingImage}
          githubLink="https://github.com/sairajesh368/NN-RF-Dataset-Analysis/tree/main/NN"
          className="min-h-[300px]"
        />
        <ProjectsCard
          title="EleNa Web Application"
          des="I developed EleNA, a sophisticated routing application that optimizes routes based on user preferences for elevation gain or loss while limiting the distance to a specified percentage of the shortest path. I applied Dijkstra’s algorithms in Python using Flask to ensure efficient route calculation. The project involved extensive geodata modeling and integration of the OpenStreetMap API for backend algorithms. To enhance user experience, I created a responsive web application using React, featuring real-time direction visualization and detailed route analytics. This project highlights my ability to combine advanced algorithms with modern web development technologies to deliver a user-centric solution for route optimization."
          src={eleNaImage}
          githubLink="https://github.com"
          className="max-h-[10px]"
        />
        {/* <ProjectsCard
          title="SOCIAL MEDIA CLONE"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={projectThree}
          githubLink="https://github.com"
        />
        <ProjectsCard
          title="E-commerce Website"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={stockMarketImage}
        />
        <ProjectsCard
          title="Chatting App"
          des=" Lorem, ipsum dolor sit amet consectetur adipisicing elit.
              Explicabo quibusdam voluptate sapiente voluptatibus harum quidem!"
          src={eleNaImage}
        /> */}
      </div>
    </section>
  );
}

export default Projects;